import type { ParsedUrlQuery } from 'querystring';
import { Locale } from '@core/internationalize/models/locale';
import { TagModalView, TAGS_MODAL_NAME } from '@engage/tags/shared';

export type AuthAction = 'device_activation' | 'add_account' | 'login';

export enum LoginPage {
  Activation = 'Activation',
  Social = 'Social',
  Standard = 'Standard',
  Tags = 'Tags',
  WebTV = 'WebTV', // mounted behind /webtv-universal-login (see apps/auth/next.config.js rewrites)
  Register = 'Register',
}

const isTagsPath = (query: ParsedUrlQuery) => {
  return query.modal === TAGS_MODAL_NAME && query.tagsView === TagModalView.TagDetails;
};
const getTag = (query: ParsedUrlQuery) => {
  return query.tagName ?? '';
};

export type OauthFragment =
  | {
      type: LoginPage.Activation;
      action: AuthAction;
      message: string;
      locale: Locale;
    }
  | {
      type: LoginPage.Tags;
      tag: string;
      message: string;
      locale: Locale;
      requesterEmail?: string;
    }
  | {
      type: LoginPage.Standard;
      message: string;
      locale: Locale;
      requesterEmail?: string;
    }
  | {
      type: LoginPage.WebTV;
      message: string;
      locale: Locale;
      origin: string;
      device: string;
    }
  | {
      type: LoginPage.Register;
      message: string;
      locale: Locale;
      origin: string;
      device: string;
    };

export const getOauthFragment = (
  query: ParsedUrlQuery,
  message: string = '',
  locale: Locale = Locale.EnglishUnitedStates,
  requesterEmail: string = '',
): OauthFragment => {
  if (isTagsPath(query)) {
    return {
      type: LoginPage.Tags,
      tag: getTag(query) as string,
      message: '',
      locale,
      requesterEmail,
    };
  }

  return {
    type: LoginPage.Standard,
    message,
    locale,
    requesterEmail,
  };
};

export const safelyDecodeFragment = (fragment: string): OauthFragment => {
  try {
    return JSON.parse(window.decodeURIComponent(fragment));
  } catch (e) {
    return {
      type: LoginPage.Standard,
      message: '',
      locale: Locale.EnglishUnitedStates,
      requesterEmail: '',
    };
  }
};
